import { Switch, Route, Redirect } from 'react-router-dom'
import { CIMSModule, CIMSPage, pathify } from 'shared'
import Administration from './components/Administration'
import Concrete from './components/Concrete'
import ConstructionAdminSubmittals from './components/ConstructionAdminSubmittals'
import DesignSubmittals from './components/DesignSubmittals'
import Home from './components/Home'
import Login from './components/Login'
import PayItems from './components/PayItems'
import ImportsExports from './components/ImportsExports'
import FieldDesignChanges from './components/FieldDesignChanges'
import RequestsForInformation from './components/RequestsForInformation'
import Issues from './components/issues/Issues'
import IdentifiedFieldIssues from './components/issues/IdentifiedFieldIssues'
import Developer from './components/Developer'
import Materials from './components/Materials'
import EngineeringJudgements from './components/EngineeringJudgements'

/**
 * @see {@link Login} component for more information
 */
export const Routes: React.FC = () => {
  const deprecated = CIMSPage.withDeprecatedPaths.flatMap((page) =>
    page.deprecatedProjectPaths.map((from) => {
      const to = from.includes(CIMSPage.deepLink)
        ? page.recordPath
        : page.projectPath
      return { from, to, key: `${from}->${to}` }
    })
  )

  return (
    <Switch>
      {deprecated.map(({ from, key, to }) => (
        <Redirect key={key} to={to} path={from} />
      ))}
      <Route exact path={'/'}>
        <Login />
      </Route>
      <Route
        path={[pathify(CIMSModule.Home.pathname), CIMSModule.Home.projectPath]}
      >
        <Home />
      </Route>
      <Route path={pathify(CIMSModule.Developer.pathname)}>
        <Developer />
      </Route>
      <Route path={CIMSModule.EJ.projectPath}>
        <EngineeringJudgements />
      </Route>
      <Route path={CIMSModule.ImportsExports.projectPath}>
        <ImportsExports />
      </Route>
      <Route path={CIMSModule.CAS.projectPath}>
        <ConstructionAdminSubmittals />
      </Route>
      <Route path={CIMSModule.DS.projectPath}>
        <DesignSubmittals />
      </Route>
      <Route path={CIMSModule.Concrete.projectPath}>
        <Concrete />
      </Route>
      <Route path={CIMSModule.Admin.projectPath}>
        <Administration />
      </Route>
      <Route path={CIMSModule.PayItems.projectPath}>
        <PayItems />
      </Route>
      <Route path={CIMSModule.FDC.projectPath}>
        <FieldDesignChanges />
      </Route>
      <Route path={CIMSModule.RFI.projectPath}>
        <RequestsForInformation />
      </Route>
      <Route path={CIMSModule.Issues.projectPath}>
        <Issues />
      </Route>
      <Route path={CIMSModule.IFI.projectPath}>
        <IdentifiedFieldIssues />
      </Route>
      <Route path={CIMSModule.Materials.projectPath}>
        <Materials />
      </Route>
    </Switch>
  )
}
